import { useEffect, useState } from 'react';
import { ContratoService } from '../../services';
import type { ContratoAlertas } from '../../services/contrato';
import Agro1Toast from '../../components/Agro1Toast';

const vencimentoTexto = (days: number) => {
  if (days > 1) return `irá vencer em ${days} dias,`;
  if (days === 1) return 'irá vencer AMANHÃ,';
  if (days === 0) return 'vence HOJE,';
  return `venceu há ${Math.abs(days)} ${
    Math.abs(days) === 1 ? 'dia' : 'dias'
  },`;
};

const ContratoAlertasComponent = () => {
  const [alertas, setAlertas] = useState<ContratoAlertas | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    ContratoService.alertas()
      .then(setAlertas)
      .catch((err) => {
        console.error('[contrato-alertas] falha ao carregar:', err);
        setError(true);
        Agro1Toast.show({
          detail: 'Não foi possível carregar informações do contrato.',
          severity: 'warn',
        });
      });
  }, []);

  if (!alertas || error) return null;

  const DIAS_ALERTA_VENCIMENTO = 30;

  const { mensagens, daysRemaining, daysToBlock } = alertas;
  const showDivergencias = mensagens.length > 0 && daysToBlock > 0;
  const showVencimento = daysRemaining <= DIAS_ALERTA_VENCIMENTO;

  if (!showDivergencias && !showVencimento) return null;

  return (
    <div className="contrato-alertas">
      {showDivergencias && (
        <div className="contrato-alerta" role="alert">
          Prezado cliente, existem divergências em seu contrato, por favor,
          entre em contato com a Agro1
          {daysToBlock > 1 && ` em até ${daysToBlock} dias,`} para evitar o
          bloqueio temporário do sistema.
          <ul>
            {mensagens.map((mensagem) => (
              <li key={mensagem}>{mensagem}</li>
            ))}
          </ul>
          <a href="/#!/parametro#contrato">Mais informações</a>
        </div>
      )}

      {showVencimento && (
        <div className="contrato-alerta" role="alert">
          <p>
            Prezado cliente, seu contrato {vencimentoTexto(daysRemaining)} por
            gentileza, entre em contato para ajustar a renovação, antes do
            bloqueio temporário do sistema.
          </p>
          <a href="/#!/parametro#contrato">Mais informações</a>
        </div>
      )}
    </div>
  );
};

export default ContratoAlertasComponent;
